'use client'
import PropTypes from "prop-types";
import * as React from "react";

// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Avatar,
  Box,
  Button,
  ButtonBase,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Toolbar,
  Typography,
  useMediaQuery
} from "@mui/material";

// third-party

// project imports
import MailListHeader from "./MailListHeader";
import MainCard from "@/app/ui-component/cards/MainCard";

// assets
import { useIntl } from "react-intl";
import { useEffect } from "react";
import "@/app/App.css";

import { useState } from "react";
import { useSelector } from "@/app/store";
import NotificationAuxEtudiantsSearchTable from "./NotificationAuxEtudiantsSearchTable";
import Controls from "@/app/reusableComponents/Controls";
import NotificationAuxEtudiantsGroupeMainSearchTable from "./NotificationAuxEtudiantsGroupeMainSearchTable";

// ==============================|| TABLE HEADER ||============================== //

// function EnhancedTableHead({ selected }) {
//   return (
//     <TableHead>
//       <TableRow>
//         <TableCell padding="none" colSpan={5}>
//           <EnhancedTableToolbar numSelected={selected.length} />
//         </TableCell>
//       </TableRow>
//     </TableHead>
//   );
// }

// EnhancedTableHead.propTypes = {
//   selected: PropTypes.array,
// };

// ==============================|| TABLE HEADER TOOLBAR ||============================== //

// const EnhancedTableToolbar = ({ numSelected }) => (
//   <Toolbar
//     sx={{
//       p: 0,
//       pl: 1,
//       pr: 1,
//       ...(numSelected > 0 && {
//         color: (theme) => theme.palette.secondary.main,
//       }),
//     }}
//   >
//     {numSelected > 0 && (
//       <Typography color="inherit" variant="h4" component="div">
//         {numSelected} Mail Selected
//       </Typography>
//     )}
//   </Toolbar>
// );

// EnhancedTableToolbar.propTypes = {
//   numSelected: PropTypes.number.isRequired,
// };

// ==============================|| CUSTOMER LIST ||============================== //

const MailList = ({
  data,
  search,
  handleSearch,
  handleDrawerOpen,
  handleUserDetails,
  handleStarredChange,
  handleImportantChange,
  messageRecuEnvoye,
  setMessageRecuEnvoye,
  readMessageSentToStudents,
  filleDataAfterCloseReadMEssage,
  mainAfterCloseRead
}) => {
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down("md"));

  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [universityID, setUniversityID] = useState(null);
  const [usuarioID, setUsuarioID] = useState(null);
  const intl = useIntl();
  const { paramMemoire } = useSelector((state) => state.diversParametersRedux);

    const childRef = React.useRef(null); // it's using a reference of a method from ImageUpLoad.js
    const childRef2 = React.useRef(null); // it's using a reference of a method from ImageUpLoad.js

    const [backGroundTable, setBackGroundTable] = useState("black");
    const [textColor, setTextColor] = useState("white");

    const [dataN, setDataN] = useState("");
    const [dataN2, setDataN2] = useState("");

    const [envoyeAuxEtudiants, setenvoyeAuxEtudiants] = useState(false);
    const [envoyeAuxAdministrateur, setenvoyeAuxAdministrateur] = useState(false);
    const [envoyeAuxAProfesseurs, setenvoyeAuxAProfesseurs] = useState(false);

  //   const [sedeID, setSedeID] = useState(null);
  /* const { notificacaoOneUser, totalNaoLida, notificacao } = useSelector(
    (state) => state.notificacaoUsuarios2
  ); */
  
  
  useEffect(() => {
    
    // Initialize the current date
var curr = new Date();
curr.setDate(curr.getDate()); 

// Convert the current date to YYYY-MM-DD format
const formattedDate = curr.toISOString().substring(0, 10);

// Ensure that these values are set correctly
setDataN(formattedDate); 
setDataN2(formattedDate);

try {
  // Assuming paramMemoire is synchronous (if not, use async/await)
  paramMemoire.map((item) => {
    setUsuarioID(item.id);
    setUniversityID(item.universityID);

  });

  // alert("messageRecuEnvoye : " + messageRecuEnvoye)

  // Ensure that universityID and usuarioID are properly set before proceeding
  if (Number(messageRecuEnvoye) ===2 && universityID && usuarioID) {
    // Log the dates before making the query

    // Pass the properly formatted date (YYYY-MM-DD) to the query
    childRef2.current.getMensagensEnvoyeall(
      universityID, 
      usuarioID, 
      1, 
      formattedDate,  // Correctly formatted start date
      formattedDate   // Correctly formatted end date
    );

    if(mainAfterCloseRead > 0) {
      childRef.current.getMensagensEnvoyeall(mainAfterCloseRead); // saveImage() = method called
    }
  }
  if (Number(messageRecuEnvoye) ===1 && universityID && usuarioID) {
    // Pass the properly formatted date (YYYY-MM-DD) to the query
    childRef2.current.getMensagensRecuAll(
      universityID, 
      usuarioID, 
      1, 
      formattedDate,  // Correctly formatted start date
      formattedDate   // Correctly formatted end date
    );

    if(mainAfterCloseRead > 0) {
      childRef.current.getMensagensRecuAll(mainAfterCloseRead); // saveImage() = method called
    }
  }
  if (Number(messageRecuEnvoye) ===2 && universityID && usuarioID) {
    // Pass the properly formatted date (YYYY-MM-DD) to the query
    childRef2.current.getMensagensEnvoyeall(
      universityID, 
      usuarioID, 
      1, 
      formattedDate,  // Correctly formatted start date
      formattedDate   // Correctly formatted end date
    );

    if(mainAfterCloseRead > 0) {
      childRef.current.getMensagensRecuAll(mainAfterCloseRead); // saveImage() = method called
    }
  }
  
} catch (error) {
  console.error("Error while fetching messages: ", error);
}

  }, [messageRecuEnvoye, filleDataAfterCloseReadMEssage, universityID, usuarioID, mainAfterCloseRead]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event?.target.value, 10));
    setPage(0);
  };

  const [denseTable, setDenseTable] = React.useState(false);
  const handleDenseTable = () => {
    setDenseTable(!denseTable);
  };

  const darkBG = theme.palette.mode === "dark" ? "dark.main" : "grey.100";

  const dateChange1 = (e) => {

    /* if(!envoyeAuxEtudiants && !envoyeAuxAProfesseurs && !envoyeAuxAdministrateur )
    {
      swal(
        intl.formatMessage({ id: "mensagem_erro_menu_atencao" }),
        intl.formatMessage({ id: "mail_choisir_type_message_envoye_error" }),
        "error"
      );
      return;
    } */
    const endDate = dataN2;
    
    // Convert both dataN and endDate (dataN2) to Date objects for comparison
    const startDate = new Date(e.target.value); 
    const newEndDate = new Date(endDate);

    const formatDate = (date) => {
      const day = String(date.getDate()).padStart(2, '0'); // Ensure two digits for day
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
      const year = date.getFullYear();
      return `${day}/${month}/${year}`; // Return in dd/MM/yyyy format
    };

    // Check if startDate is earlier than newEndDate
    if (startDate > newEndDate) {
      swal(
        intl.formatMessage({ id: "mensagem_erro_menu_atencao" }),
        intl.formatMessage({ id: "date1_inferieur_a_date2" }),
        "error"
      );
      return; // Return early to avoid making a query with invalid dates
     
    }
  
    // Proceed if the date range is valid
    setDataN(e.target.value);
    if(Number(messageRecuEnvoye) ===1)
    {
    childRef2.current.getMensagensRecuAll(universityID, usuarioID, 1, formatDate(startDate), formatDate(newEndDate)); // Call method with the correct date range
    }

    if(Number(messageRecuEnvoye) ===2)
    {
    childRef2.current.getMensagensEnvoyeall(universityID, usuarioID, 1, formatDate(startDate), formatDate(newEndDate)); // Call method with the correct date range
    }

   // tableFillData(universityID, e.target.value, dataN2)
  }
  const dateChange2 = (e) => {

   /*  if(!envoyeAuxEtudiants && !envoyeAuxAProfesseurs && !envoyeAuxAdministrateur )
    {
      swal(
        intl.formatMessage({ id: "mensagem_erro_menu_atencao" }),
        intl.formatMessage({ id: "mail_choisir_type_message_envoye_error" }),
        "error"
      );
      return;
    } */
    const endDate = e.target.value;
  
    // Convert both dataN and endDate (dataN2) to Date objects for comparison
    const startDate = new Date(dataN); 
    const newEndDate = new Date(endDate);
    
    // Make sure that both `startDate` and `newEndDate` are valid Date objects
    if (isNaN(startDate.getTime()) || isNaN(newEndDate.getTime())) {
      // console.error("Invalid date detected.");
      return;
    }
  
    // Function to format the date to dd/MM/yyyy
    const formatDate = (date) => {
      const day = String(date.getDate()).padStart(2, '0'); // Ensure two digits for day
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
      const year = date.getFullYear();
      return `${day}/${month}/${year}`; // Return in dd/MM/yyyy format
    };
  
    // Check if startDate is earlier than newEndDate
    if (startDate > newEndDate) {
      swal(
        intl.formatMessage({ id: "mensagem_erro_menu_atencao" }),
        intl.formatMessage({ id: "date1_inferieur_a_date2" }),
        "error"
      );
      return; // Return early to avoid making a query with invalid dates
    }
  
    // Proceed if the date range is valid
    setDataN2(endDate); // Update the state

    if(Number(messageRecuEnvoye) ===1)
    {
      childRef2.current.getMensagensRecuAll(universityID, usuarioID, 1, formatDate(startDate), formatDate(newEndDate)); // Call method with the correct date range
    }

    if(Number(messageRecuEnvoye) ===2)
    {
      childRef2.current.getMensagensEnvoyeall(universityID, usuarioID, 1, formatDate(startDate), formatDate(newEndDate)); // Call method with the correct date range
    }
  };

  const visualizerLesDonneeEtudiants = (mainID) => {

    console.log("mainID : ", mainID);
    
   /*  if(!envoyeAuxEtudiants && !envoyeAuxAProfesseurs && !envoyeAuxAdministrateur )
    {
      swal(
        intl.formatMessage({ id: "mensagem_erro_menu_atencao" }),
        intl.formatMessage({ id: "mail_choisir_type_message_envoye_error" }),
        "error"
      );
      return;
    } */
    try {
      childRef.current.getMensagensEnvoyeall(mainID); // saveImage() = method called

    } catch (error) {
      
    }
  }

  const handleChangeEnvoyeAuxEtudiant = async(event) => {

    if(event.target.checked) {
      setenvoyeAuxEtudiants(true);
      setenvoyeAuxAdministrateur(false);
      setenvoyeAuxAProfesseurs(false);

     /*  setValues((prevState) => ({
        ...prevState,
        turnoActualOuiNon: 1
      })); */
    }
  };

  const handleChangeEnvoyeAuxProfesseurs = async(event) => {

    if(event.target.checked) {
      setenvoyeAuxEtudiants(false);
      setenvoyeAuxAdministrateur(false);
      setenvoyeAuxAProfesseurs(true);

     /*  setValues((prevState) => ({
        ...prevState,
        turnoActualOuiNon: 1
      })); */
    }
  };

  const handleChangeEnvoyeAuxAdministratifs = async(event) => {

    if(event.target.checked) {
      setenvoyeAuxEtudiants(false);
      setenvoyeAuxAdministrateur(true);
      setenvoyeAuxAProfesseurs(false);

     /*  setValues((prevState) => ({
        ...prevState,
        turnoActualOuiNon: 1
      })); */
    }
  };


  return (
    <>
      <Grid container spacing={matchDownSM ? 3 : 1}>

        <Grid item xs={12}>
          <MailListHeader
            search={search}
            handleSearch={handleSearch}
            length={data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleDrawerOpen={handleDrawerOpen}
            handleDenseTable={handleDenseTable}
          />
        </Grid>
        </Grid>
    
    {messageRecuEnvoye > 0 ?
  <MainCard
  title={
    <Grid container alignItems="center" justifyContent="space-between" spacing={0}>
      {/* Title on the left */}
      <Grid item>
        <Typography variant="h3">
          {Number(messageRecuEnvoye) === 22 ?
          intl.formatMessage({ id: "message_envoyes" }):
          messageRecuEnvoye ===1? intl.formatMessage({ id: "message_recus" })
            : intl.formatMessage({ id: "message_envoyes" })}
        </Typography>
      </Grid>

      {/* Checkboxes aligned in the right corner */}
      <Grid item>
        <FormGroup row sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
          <FormControlLabel
            control={
            <Checkbox 
              name="envoyeAuxEtudiants" 
              checked={envoyeAuxEtudiants}
              onChange={handleChangeEnvoyeAuxEtudiant}
              id="1" 
              color="primary" />}
            label={intl.formatMessage({ id: "mensagen_enviye_aux_etudants" })}
            sx={{ mr: 2 }}  // margin-right to space out checkboxes
          />
          <FormControlLabel
            control={
            <Checkbox 
              name="envoyeAuxAProfesseurs" 
              checked={envoyeAuxAProfesseurs}
              onChange={handleChangeEnvoyeAuxProfesseurs}
              id="2" 
              color="secondary" />}
            label={intl.formatMessage({ id: "mensagen_enviye_aux_professeur" })}
            sx={{ mr: 2 }}  // margin-right to space out checkboxes
          />
          <FormControlLabel
            control={
            <Checkbox 
            name="envoyeAuxAdministrateur" 
            checked= {envoyeAuxAdministrateur}
            onChange={handleChangeEnvoyeAuxAdministratifs}
              id="3" 
              color="secondary" />}
            label={intl.formatMessage({ id: "mensagen_enviye_aux_administrateurs" })}
          />
    
        </FormGroup>
        <Grid item xs={12}>
        <Grid container spacing={2} alignItems="left" justify="flex-end">
       
        <Grid item xs={6}>
        <Controls.Input
        component12SansText
          name="dataJour"
          label={intl.formatMessage({ id: "date_debut" })}
          value={dataN}
          type="date"
          width="100%"
          marginLeft="0px"
          onChange={dateChange1}
        />
        </Grid>
      <Grid item xs={6}>

<Controls.Input
      component12SansText
        name="dataJour2"
        label={intl.formatMessage({ id: "date_fin" })}
        value={dataN2}
        type="date"
        width="100%"
        marginLeft="0px"
        onChange={dateChange2}

            />
            </Grid>
      </Grid>
      </Grid>

     </Grid>
    </Grid>
  }
>
  <Grid container spacing={1}>

        <Grid item xs={12}>
    <Grid item xs={12}>
      <NotificationAuxEtudiantsGroupeMainSearchTable
        ref={childRef2}
        dadosTable={data}
        idDisplay={false}
        dataDisplay
        horaDisplay
        tituloDisplay
        mensagemDisplay={false}
        lidaDisplay
        userNameDisplay
        userPhotoDisplay
        userID={usuarioID}
        universityID={universityID}
        actionsButtonDisplayEditDelete
        backGroundColor={backGroundTable}
        color={textColor}
        pageSize={100}
        rowPerPage={100}
        messageRecuEnvoye={messageRecuEnvoye}
        handleDrawerOpen={handleDrawerOpen}
        visualizerLesDonneeEtudiants = {visualizerLesDonneeEtudiants}
        readMessageSentToStudents = {readMessageSentToStudents}

      />
    </Grid>
    {envoyeAuxEtudiants ? 
    <Grid item xs={12}>
      <NotificationAuxEtudiantsSearchTable
        ref={childRef}
        dadosTable={data}
        idDisplay={false}
        dataDisplay
        horaDisplay
        tituloDisplay
        mensagemDisplay={false}
        lidaDisplay
        userNameDisplay
        userPhotoDisplay
        userID={usuarioID}
        universityID={universityID}
        actionsButtonDisplayEditDelete
        backGroundColor={backGroundTable}
        color={textColor}
        pageSize={100}
        rowPerPage={100}
        messageRecuEnvoye={messageRecuEnvoye}
        handleDrawerOpen={handleDrawerOpen}
        readMessageSentToStudents = {readMessageSentToStudents}
      />
    </Grid>
      :null}
  </Grid>
  </Grid>
</MainCard>

     
        :
        <>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
        <Typography variant="h3">
        {intl.formatMessage({ id: "choisir_le_type_de_messae_a_visualiser" })}
         </Typography>
         </div>
         <hr/>
         <div>
         <Typography variant="h5">
        {intl.formatMessage({ id: "choisir_le_type_de_message_a_visualiser2" })}
         </Typography>
         </div>
          <div>
         <Typography variant="h5">
        {intl.formatMessage({ id: "choisir_le_type_de_message_a_visualiser3" })}
         </Typography>
         </div>
         </>

}
    </>
  );
};

MailList.propTypes = {
  data: PropTypes.array,
  handleDrawerOpen: PropTypes.func,
  handleUserDetails: PropTypes.func,
  handleStarredChange: PropTypes.func,
  handleImportantChange: PropTypes.func,
  handleSearch: PropTypes.func,
  search: PropTypes.string,
};

export default MailList;
